import {
  deleteItemFromCollection,
  getItemFromCollection,
} from "directus/src/operations";

export async function deleteTimesheetEntry({ id }) {
  try {
    const query = {
      fields: ["id"],
    };
    const data = await deleteItemFromCollection("timesheet", id, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchTimesheetEntry({ timesheetId }) {
  try {
    const query = {
      fields: [
        "approved_hours",
        "date",
        "description",
        "employee.avatar",
        "employee.first_name",
        "employee.last_name",
        "id",
        "job.id",
        "job.name",
        "logged_hours",
        "milestone.id",
        "milestone.name",
        "tag",
        "tag.id",
        "tag.label",
        "project.id",
        "project.name",
        "unapproved_hours",
        "reason",
      ],
    };
    const res = await getItemFromCollection("timesheet", timesheetId, query);
    return res;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
